import React from 'react';
import { Box, Typography } from '@mui/material';
import projectData from '../data/project_data.json';

export default function ProjectPage() {
  return (
    <Box id="projects">
      <Typography
        sx={{
          fontFamily: '"Space Grotesk", sans-serif',
          color: '#EDEFF7',
          fontSize: '22px',
          fontWeight: 600,
          mb: 1,
        }}
      >
        Projects
      </Typography>
      <Typography sx={{ color: '#7B8AC0', fontSize: '15px', mb: '28px' }}>
        Here are some of the projects I have contributed to
      </Typography>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
        {projectData.map((project, i) => (
          <Box
            key={i}
            component="a"
            href={project.infoUrl}
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              display: 'flex',
              gap: '20px',
              bgcolor: '#0F1436',
              border: '1px solid rgba(111,243,232,0.10)',
              borderRadius: '10px',
              padding: '16px',
              alignItems: 'center',
              textDecoration: 'none',
              transition: 'border-color 0.2s',
              '&:hover': { borderColor: 'rgba(111,243,232,0.30)' },
            }}
          >
            <Box
              component="img"
              src={project.imageUrl}
              alt={project.projectTitle}
              sx={{
                width: 150,
                height: 100,
                objectFit: 'cover',
                borderRadius: '6px',
                flexShrink: 0,
              }}
            />
            <Box sx={{ flex: 1, minWidth: 0 }}>
              <Typography
                sx={{
                  color: '#6FF3E8',
                  fontWeight: 600,
                  fontSize: '16px',
                  fontFamily: '"Space Grotesk", sans-serif',
                }}
              >
                {project.projectTitle}
              </Typography>
              <Typography
                sx={{
                  color: '#A8BEF0',
                  fontSize: '13.5px',
                  mt: '6px',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  display: '-webkit-box',
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: 'vertical',
                }}
              >
                {project.shortDescription}
              </Typography>
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: '6px', mt: '10px' }}>
                {project.skills.slice(0, 3).map(s => (
                  <Box
                    key={s}
                    component="span"
                    sx={{
                      bgcolor: '#131A45',
                      color: '#6FF3E8',
                      fontSize: '11px',
                      px: '8px',
                      py: '2px',
                      borderRadius: '10px',
                    }}
                  >
                    {s}
                  </Box>
                ))}
              </Box>
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
}
